import type { Setting } from "@/lib/settings.api";
import { MODULE_DESCRIPTIONS, MODULE_LABELS } from "../../settingsPage.constants";
import { SettingControl } from "./SettingControl";

interface SystemSettingsModuleSectionProps {
  module: string;
  items: Setting[];
  drafts: Record<string, string>;
  saving: string | null;
  onDraftChange: (key: string, value: string) => void;
  onSave: (key: string) => void | Promise<void>;
}

export function SystemSettingsModuleSection({
  module,
  items,
  drafts,
  saving,
  onDraftChange,
  onSave,
}: SystemSettingsModuleSectionProps) {
  return (
    <section className="border border-border bg-card">
      <div className="grid gap-2 border-b border-border px-4 py-3 md:grid-cols-[minmax(0,1fr)_auto] md:items-start">
        <div>
          <h3 className="text-sm font-semibold text-foreground">
            {MODULE_LABELS[module] ?? module}
          </h3>
          <p className="mt-1 text-xs text-muted-foreground">
            {MODULE_DESCRIPTIONS[module] ?? "Paramètres opérationnels du module."}
          </p>
        </div>
        <span className="text-xs text-muted-foreground">
          {items.length} option{items.length > 1 ? "s" : ""}
        </span>
      </div>

      <div className="grid gap-3 p-3 md:grid-cols-2 xl:grid-cols-3">
        {items.map((setting) => (
          <SettingControl
            key={setting.key}
            setting={setting}
            value={drafts[setting.key] ?? ""}
            dirty={drafts[setting.key] !== setting.value}
            saving={saving === setting.key}
            onChange={(value) => onDraftChange(setting.key, value)}
            onSave={() => onSave(setting.key)}
          />
        ))}
      </div>
    </section>
  );
}
